import { Component } from "react";
import UserHome from "../../Components/Pages/Home";
import { showSuccess } from "../../utils/Toast";
import { getBuyerToken } from "../../utils/authStorage";
import { addGuestCartItem } from "../../utils/guestCart";

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setAuthModalOpen: false,
    };
  }

  componentDidMount() {
    const {
      getProductRequest,
      getHomeproductdataRequest,
      getBrandRequest,
      getcategorywithsubcategoryRequest,
      getBannersRequest,
    } = this.props;
    getProductRequest();
    getHomeproductdataRequest();
    getBrandRequest();
    getcategorywithsubcategoryRequest();
    getBannersRequest();
  }

  componentDidUpdate(prevProps) {
    const {
      addcartdata,
      getCartRequest,
      addwishlistdata,
      getHomeproductdataRequest,
      getProductRequest,
      removewishlistdata,
    } = this.props;
    if (prevProps.addcartdata !== this.props.addcartdata) {
      const { addcartdata } = this.props;
      if (addcartdata && addcartdata.success) {
        getCartRequest();
        showSuccess("Cart Added Successfully");
      }
    }
    if (prevProps.addwishlistdata !== this.props.addwishlistdata) {
      if (addwishlistdata && addwishlistdata.success) {
        getHomeproductdataRequest();
        getProductRequest();
        showSuccess("Wish List Added Successfully");
      }
    }
    if (prevProps.removewishlistdata !== this.props.removewishlistdata) {
      if (removewishlistdata && removewishlistdata.success) {
        getHomeproductdataRequest();
        getProductRequest();
        showSuccess("Wish List Removed Successfully");
      }
    }
  }

  onclickcart = (data) => {
    const { insertCartRequest } = this.props;
    // console.log("data", data);
    const payload = {
      product_id: data?.id ?? data?.product_id, // number
      quantity: data?.quantity ? Number(data.quantity) : 1, // number
      price: Number(data?.price ?? 0), // number
      discount: Number(data?.discount ?? 0), // number
      attributes: data.original.attributes,
    };

    if (!payload.product_id) {
      return;
    }

    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      return;
    }

    insertCartRequest(payload);
    // console.log("Adding to cart payload ->", payload);
  };

  closeAuthModal = () => {
    this.setState({ setAuthModalOpen: false });
  };

  render() {
    const {
      insertCartRequest,
      getcategoryRequest,
      categorydata,
      productdata,
      Homeproductdata,
      getproductbycategoryidRequest,
      addwishlistrequest,
      removewishlistrequest,
      branddata,
      categorywithsubcategorydata,
      getproductwithbrandRequest,
      topBanners,
      smallBanners,
      smallBanner,
      bottomBanners,
      loading,
    } = this.props;

    // console.log("Homeproductdata", Homeproductdata);

    const { setAuthModalOpen } = this.state;
    return (
      <>
        <UserHome
          insertCartRequest={insertCartRequest}
          getcategoryRequest={getcategoryRequest}
          categorydata={categorydata}
          onclickcart={this.onclickcart}
          productdata={productdata}
          Homeproductdata={Homeproductdata}
          getproductbycategoryidRequest={getproductbycategoryidRequest}
          setAuthModalOpen={setAuthModalOpen}
          closeAuthModal={this.closeAuthModal}
          addwishlistrequest={addwishlistrequest}
          removewishlistrequest={removewishlistrequest}
          branddata={branddata}
          categorywithsubcategorydata={categorywithsubcategorydata}
          getproductwithbrandRequest={getproductwithbrandRequest}
          topBanners={topBanners}
          smallBanners={smallBanners}
          smallBanner={smallBanner}
          bottomBanners={bottomBanners}
          loading={loading}
        />
      </>
    );
  }
}

export default Home;
